import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchFeatureFlags } from '../features/featureFlags/featureFlags'
import { TOKEN_REFRESHED } from '../lib/authEvents'

const useFeatureFlagsRefresh = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    const refresh = () => dispatch(fetchFeatureFlags())

    refresh()

    const onVisible = () => {
      if (document.visibilityState === 'visible') refresh()
    }

    window.addEventListener('focus', refresh)
    // WS #2304782: the read made with an expired token got the signed-out list.
    window.addEventListener(TOKEN_REFRESHED, refresh)
    document.addEventListener('visibilitychange', onVisible)

    return () => {
      window.removeEventListener('focus', refresh)
      window.removeEventListener(TOKEN_REFRESHED, refresh)
      document.removeEventListener('visibilitychange', onVisible)
    }
  }, [dispatch])
}

export default useFeatureFlagsRefresh
